import { Component, OnInit } from "@angular/core";
import { Company } from "../../../models/company";
import { Router, ActivatedRoute } from "@angular/router";
import { Page } from "../../../models/paging/page";
import { ModalService } from "../../../services/modal.service";
import { ColumnService } from "../../../services/ColumnService";
import { AuthService } from "../../../services/auth.service";
import { ManagedCylinderInformationService } from "../../../services/managed-cylinder-information.service";

@Component({
  selector: "app-managed-cylinder-information",
  templateUrl: "./managed-cylinder-information.component.html",
  styleUrls: ["./managed-cylinder-information.component.css"],
})
export class ManagedCylinderInformationComponent implements OnInit {
  modalService: ModalService;
  companies: Company[];
  client;

  locationId: number;
  address1: string;

  filter: any = {
    quick_Search: "",
  };

  availableOptions: string[] = [
    "Product Type",
    "Product Type Abr",
    "Cylinder Size",
    "Target",
    "Daily Average Usage",
    "Minimum",
    "Edit"
  ];

  selectedOptions: string[] = [
    "Product Type",
    "Product Type Abr",
    "Cylinder Size",
    "Target",
    "Daily Average Usage",
    "Minimum",
    "Edit"
  ];

  entity = "";
  showHistory: boolean = false;

  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(
    authService: AuthService,
    private managedCylinderInfoService: ManagedCylinderInformationService,
    private router: Router,
    private route: ActivatedRoute,
    modalService: ModalService,
    private columnService: ColumnService
  ) {
    this.client = authService.currentUser.value;
    this.modalService = modalService;
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
    this.getcolumns();

    this.route.queryParams.subscribe((params) => {
      this.locationId = +params["locationId"] || 0;
      this.address1 = params["address1"] || "";
      this.loadTable(this.page);
    });
  }

  createManagedCylinderInformation() {
    this.router.navigate(
      ['administration/managed-cylinder-information-management/manage'],
      {
        queryParams: {
          locationId: this.locationId,
          address1: this.address1,
        }
      }
    );
  }

  editManagedCylinderInformation(row: any) {
    this.router.navigate(
      ['administration/managed-cylinder-information-management/manage'],
      {
        queryParams: {
          managedCylinderInfoId: row.managed_Cyl_Info_ID,
          locationId: this.locationId,    
          address1: this.address1,       
        },
      }
    );
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == "") {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.managedCylinderInfoService
      .getResults(page, this.locationId, this.filter.quick_Search)
      .then((pagedData) => {
        console.log("ppage data", JSON.stringify(pagedData.data, null, 4));
        
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    console.log("triggered");
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    console.log("current user", this.client.userId);

    this.columnService
      .getColumns(this.client.userId, "managedCylinderInformation")
      .then((data) => {
        if (data.columns != null) {
          this.selectedOptions = this.availableOptions.filter((c) => {
            return data.columns.includes(c);
          });
        }
      });
  }

  saveSelection() {
    this.columnService
      .save(this.client.userId, "managedCylinderInformation", this.selectedOptions)
      .then((data) => { });
  }

}